import React from 'react';
import EagleAIWebsite from './components/EagleAIWebsite';
import './App.css';

function App() {
  return (
    <div className="App">
      <EagleAIWebsite />
    </div>
  );
}

export default App;